module.exports = __webpack_public_path__ + "img/nhm_new.98fba314.png";